var _circle, _path, _g, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 136,
    viewBox: "0 0 128 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 72,
    r: 64,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6737 122.167H18.209C17.5108 122.167 16.8195 122.03 16.1745 121.762C15.5295 121.495 14.9434 121.104 14.4497 120.61C13.956 120.116 13.5644 119.53 13.2973 118.885C13.0301 118.24 12.8926 117.549 12.8926 116.851V25.1318C12.8926 23.7218 13.4527 22.3696 14.4497 21.3726C15.4467 20.3755 16.799 19.8154 18.209 19.8154H57.6391L80.9901 43.1665V116.851C80.9901 118.261 80.43 119.613 79.433 120.61C78.436 121.607 77.0837 122.167 75.6737 122.167Z",
    fill: "#DDDDDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1654_5860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.6239 110.633H29.1592C28.461 110.633 27.7697 110.495 27.1247 110.228C26.4797 109.961 25.8936 109.569 25.3999 109.076C24.9062 108.582 24.5146 107.996 24.2475 107.351C23.9803 106.706 23.8428 106.015 23.8428 105.316V13.5976C23.8428 12.8995 23.9803 12.2082 24.2475 11.5631C24.5146 10.9181 24.9062 10.3321 25.3999 9.83838C25.8936 9.34471 26.4797 8.95311 27.1247 8.68594C27.7697 8.41876 28.461 8.28125 29.1592 8.28125H68.5893L91.9403 31.6323V105.316C91.9403 106.015 91.8028 106.706 91.5356 107.351C91.2685 107.996 90.8769 108.582 90.3832 109.076C89.8895 109.569 89.3034 109.961 88.6584 110.228C88.0134 110.495 87.3221 110.633 86.6239 110.633Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9394 31.6323H73.9048C72.4948 31.6323 71.1425 31.0722 70.1455 30.0752C69.1485 29.0782 68.5884 27.7259 68.5884 26.3159V8.28125L91.9394 31.6323Z",
    fill: "#C7C7C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9862 84.442L82.0576 89.3706L100.605 107.918L105.533 102.989L86.9862 84.442Z",
    fill: "#1991EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 35.6992C24.8808 41.1308 21.1819 48.0511 19.6833 55.585C18.1847 63.1189 18.9538 70.9279 21.8934 78.0247C24.833 85.1214 29.811 91.1871 36.1979 95.4547C42.5848 99.7223 50.0938 102 57.7752 102C65.4567 102 72.9657 99.7223 79.3526 95.4547C85.7395 91.1871 90.7175 85.1214 93.657 78.0247C96.5966 70.9279 97.3657 63.1189 95.8672 55.585C94.3686 48.0511 90.6696 41.1308 85.238 35.6992C81.6315 32.0927 77.35 29.2319 72.638 27.2801C67.9259 25.3283 62.8755 24.3237 57.7752 24.3237C52.6749 24.3237 47.6246 25.3283 42.9125 27.2801C38.2004 29.2319 33.9189 32.0927 30.3125 35.6992ZM80.1726 85.5593C75.7428 89.9891 70.0989 93.0059 63.9546 94.228C57.8103 95.4502 51.4416 94.8229 45.6538 92.4256C39.866 90.0282 34.9191 85.9683 31.4386 80.7595C27.9582 75.5506 26.1005 69.4266 26.1005 63.1619C26.1005 56.8973 27.9582 50.7733 31.4387 45.5644C34.9191 40.3555 39.866 36.2957 45.6538 33.8983C51.4416 31.501 57.8104 30.8737 63.9547 32.0959C70.099 33.3181 75.7428 36.3348 80.1726 40.7646C86.1128 46.7047 89.4499 54.7613 89.4499 63.162C89.4499 71.5626 86.1128 79.6192 80.1726 85.5593Z",
    fill: "#1991EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8982 93.5173L90.8982 93.5173C87.8095 96.606 87.8095 101.614 90.8982 104.702L102.606 116.411C105.695 119.499 110.703 119.499 113.791 116.41C116.88 113.322 116.88 108.314 113.791 105.225L102.083 93.5173C98.9946 90.4287 93.9869 90.4287 90.8982 93.5173Z",
    fill: "#055897"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1654_5860",
    x: 14.9018,
    y: 0.532408,
    width: 85.9796,
    height: 120.234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19213
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.47049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1654_5860"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1654_5860",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.591605cf1b03835c5f0911455dfc21cd.svg";
export { ForwardRef as ReactComponent };